module.exports = __webpack_public_path__ + "img/Terraform-Sales-1-mobile.29005856.png";